import moment from 'moment';

export const log = (message: string, data: unknown = null) => {
  try {
    console.log('[WSCLANS] [' + moment.utc().toISOString() + '] ' + message + ' ' + JSON.stringify(data));
  } catch (e) {
    // ..
  }
};
